
const suffix = process.env.VUE_APP_SUFFIX
const getRealData = process.env.VUE_APP_SSJK_WS_URL

const urls = class{
	static m(){
		// 登录接口
		const login = `${suffix}/oauth2/token`
		//const login = `${url}login`

		const getRealDataForChart = `${suffix}/device/getRealDataForChart`
		const getRealDataForChartNm = `${suffix}/device/getRealDataForChartNm`


		//文件上传
		const updateFileUrlOne = `${suffix}/common/commonUploadFile_uploadOne`
		//公共日志
		const commonLog_list = `${suffix}/common/commonLog_list`

		//首页数据
		const index_statData = `${suffix}/index_statData`
		const index_statData2 = `${suffix}/index_statData2`

		//数据字典
		const sysDict_saveOrUpdateItem = `${suffix}/sys/sysDict_saveOrUpdateItem`
		const sysDict_deleteItem = `${suffix}/sys/sysDict_deleteItem`
		const sysDict_listItem = `${suffix}/sys/sysDict_listItem`
		const sysDict_listItemByDictId = `${suffix}/sys/sysDict_listItemByDictId`
		const sysDict_listItemByCode = `${suffix}/sys/sysDict_listItemByCode`
		const sysDict_listItemByDesc = `${suffix}/sys/sysDict_listItemByDesc`
		const sysDict_listItemByDictIdAndDesc = `${suffix}/sys/sysDict_listItemByDictIdAndDesc`
		const sysDict_getForCode = `${suffix}/sys/sysDict_getForCode`
		const sysDict_list = `${suffix}/sys/sysDict_list`
		const sysDict_getDetail = `${suffix}/sys/sysDict_getDetail`
		const sysDict_listComByDictId = `${suffix}/sys/sysDict_listComByDictId`

		//缓存清理
		const cache_clear = `${suffix}/sys/cache_clear`


		//角色URL
		const sysRole_list = `${suffix}/sys/sysRole_list`
		const sysRole_save = `${suffix}/sys/sysRole_save`
		const sysRole_update = `${suffix}/sys/sysRole_update`
		const sysRole_delete = `${suffix}/sys/sysRole_delete`
		const sysRole_getDetail = `${suffix}/sys/sysRole_getDetail`
		const sysRole_listCom = `${suffix}/sys/sysRole_listCom`
		const sysRole_getCompanyRoleList = `${suffix}/sys/sysRole_getCompanyRoleList`

		//日志列表
		const sysLog_list = `${suffix}/sys/sysLog_list`
		const sysLog_getDetail = `${suffix}/sys/sysLog_getDetail`
		//组织机构
		const sysDept_listCom = `${suffix}/sys/sysDept_listCom`
		const sysDept_list = `${suffix}/sys/sysDept_list`
		const sysDept_save = `${suffix}/sys/sysDept_save`
		const sysDept_update = `${suffix}/sys/sysDept_update`
		const sysDept_delete = `${suffix}/sys/sysDept_delete`
		const sysDept_getDetail = `${suffix}/sys/sysDept_getDetail`

		//用户列表
		const sysUser_getSessionUser = `${suffix}/sys/sysUser_getSessionUser`
		const sysUser_list = `${suffix}/sys/sysUser_list`
		const sysUser_save = `${suffix}/sys/sysUser_save`
		const sysUser_delete = `${suffix}/sys/sysUser_delete`
		const sysUser_getDetail = `${suffix}/sys/sysUser_getDetail`
		const sysUser_updatePassword = `${suffix}/sys/sysUser_updatePassword`
		const sysUser_updateParams = `${suffix}/sys/sysUser_updateParams`
		//反馈中心
		const appFeedback_list = `${suffix}/app/appFeedback_list`
		const appFeedback_getDetail = `${suffix}/app/appFeedback_getDetail`
		const appFeedback_save = `${suffix}/app/appFeedback_save`
		const appFeedback_delete = `${suffix}/app/appFeedback_delete`
		const appFeedback_updateCl = `${suffix}/app/appFeedback_updateCl`
		const appFeedback_indexData = `${suffix}/app/appFeedback_indexData`
		//任务管理task
		const task_list = `${suffix}/task/task_list`
		const task_getDetail = `${suffix}/task/task_getDetail`
		const task_delete = `${suffix}/task/task_delete`
		const  task_updateSetRead = `${suffix}/task/task_updateSetRead`
		const task_getNoDeal = `${suffix}/task/task_getNoDeal`


		//企业管理
		const company_list = `${suffix}/company/company_list`
		const company_getDetail = `${suffix}/company/company_getDetail`
		const company_saveOrUpdate = `${suffix}/company/company_saveOrUpdate`
		const company_delete = `${suffix}/company/company_delete`
		const company_updateSh = `${suffix}/company/company_updateSh`
		const company_importExcel = `${suffix}/company/company_importExcel`
		const company_downImportModel = `${suffix}/company/company_downImportModel`
		const company_exportExcel = `${suffix}/company/company_exportExcel`
		const company_listCom = `${suffix}/company/company_listCom`
		const company_updateAllNums = `${suffix}/company/company_updateAllNums`
		const company_getInfor = `${suffix}/company/company_getInfor`
		const company_updateForCompanyUser = `${suffix}/company/company_updateForCompanyUser`
		const company_updateParams = `${suffix}/company/company_updateParams`
		const company_migration = `${suffix}/company/company_migration`
		const company_getDetailByUser = `${suffix}/company/company_getDetailByUser`
		//懒加载
		const company_getTreeNodeV2 = `${suffix}/company/company_getTreeNodeV2`


		//权限相关
		const sysPower_getRoleModulesTree = `${suffix}/sys/sysPower_getRoleModulesTree`
		const sysPower_saveRoleModules = `${suffix}/sys/sysPower_saveRoleModules`
		const sysPower_saveUserRoles = `${suffix}/sys/sysPower_saveUserRoles`
		//根据用户获取菜单
		const sysPower_listUserModule = `${suffix}/sys/sysPower_listUserModule`
		//用户角色选择初始化
		const sysUser_getUserRolesTree = `${suffix}/sys/sysUser_getUserRolesTree`
		//用户详情
		const getmessage = `${suffix}/index/getmessage`
		//deptId查询页面
		const sysdept_listWeb = `/index_new.html`


		//权限管理
		const sysPower_getTopMenu = `${suffix}/sys/sysPower_getTopMenu`
		const menuByUser = `${suffix}/index1/index_statData`

		//设备控制器版本管理
		const deviceVersion_list = `${suffix}/device/deviceVersion_list`
		const deviceVersion_getDetail = `${suffix}/device/deviceVersion_getDetail`
		const deviceVersion_saveOrUpdate = `${suffix}/device/deviceVersion_saveOrUpdate`
		const deviceVersion_delete = `${suffix}/device/deviceVersion_delete`
		const deviceVersion_exportExcel = `${suffix}/device/deviceVersion_exportExcel`
		const deviceVersionLog_list = `${suffix}/device/deviceVersionLog_list`
		const deviceVersionLog_exportExcel = `${suffix}/device/deviceVersionLog_exportExcel`
		const deviceVersion_listForDeviceId = `${suffix}/device/deviceVersion_listForDeviceId`



		//售后申请
		const deviceAfterSalesApply_list = `${suffix}/device/deviceAfterSalesApply_list`
		const deviceAfterSalesApply_getDetail = `${suffix}/device/deviceAfterSalesApply_getDetail`
		const deviceAfterSalesApply_saveOrUpdate = `${suffix}/device/deviceAfterSalesApply_saveOrUpdate`
		const deviceAfterSalesApply_delete = `${suffix}/device/deviceAfterSalesApply_delete`
		const deviceAfterSalesApply_updateSh = `${suffix}/device/deviceAfterSalesApply_updateSh`
		const deviceAfterSalesApply_importExcel = `${suffix}/device/deviceAfterSalesApply_importExcel`
		const deviceAfterSalesApply_downImportModel = `${suffix}/device/deviceAfterSalesApply_downImportModel`
		const deviceAfterSalesApply_exportExcel = `${suffix}/device/deviceAfterSalesApply_exportExcel`
		const deviceAfterSalesRecord_updateDeal = `${suffix}/device/deviceAfterSalesRecord_updateDeal`
		const deviceAfterSalesApply_listNoDealData = `${suffix}/device/deviceAfterSalesApply_listNoDealData`

		//砂浆罐运行状态
		const deviceInforState_list = `${suffix}/device/deviceInforState_list`
		const deviceInforState_getDetail = `${suffix}/device/deviceInforState_getDetail`
		const deviceInforState_saveOrUpdate = `${suffix}/device/deviceInforState_saveOrUpdate`
		const deviceInforState_delete = `${suffix}/device/deviceInforState_delete`
		const deviceInforState_updateSh = `${suffix}/device/deviceInforState_updateSh`
		const deviceInforState_importExcel = `${suffix}/device/deviceInforState_importExcel`
		const deviceInforState_downImportModel = `${suffix}/device/deviceInforState_downImportModel`
		const deviceInforState_exportExcel = `${suffix}/device/deviceInforState_exportExcel`
		//砂浆罐信息
		const deviceInfor_list = `${suffix}/device/deviceInfor_list`
		const deviceInfor_getDetail = `${suffix}/device/deviceInfor_getDetail`
		const deviceInfor_getAllDetail = `${suffix}/device/deviceInfor_getAllDetail`
		const deviceInfor_getUseAndPutLog = `${suffix}/device/deviceInfor_getUseAndPutLog`
		const deviceInfor_getUseAndPutChart = `${suffix}/device/deviceInfor_getUseAndPutChart`
		const deviceInfor_saveOrUpdate = `${suffix}/device/deviceInfor_saveOrUpdate`
		const deviceInfor_saveMore = `${suffix}/device/deviceInfor_saveMore`


		const deviceInfor_delete = `${suffix}/device/deviceInfor_delete`
		const deviceInfor_getSum = `${suffix}/device/deviceInfor_getSum`
		const deviceInfor_saveMigrate = `${suffix}/device/deviceInfor_saveMigrate`
		const deviceInfor_importExcel = `${suffix}/device/deviceInfor_importExcel`
		const deviceInfor_importExcelAli = `${suffix}/device/deviceInfor_importExcelAli`

		const deviceInfor_downImportModel = `${suffix}/device/deviceInfor_downImportModel`
		const deviceInfor_downImportModelAli = `${suffix}/device/deviceInfor_downImportModelAli`
		const deviceInfor_exportExcel = `${suffix}/device/deviceInfor_exportExcel`
		const deviceInfor_getAuto = `${suffix}/device/deviceInfor_getAuto`
		const deviceInfor_updateSetZt = `${suffix}/device/deviceInfor_updateSetZt`
		const deviceInfor_updateSetZtV2 = `${suffix}/device/deviceInfor_updateSetZtV2`
		const deviceInfor_updateSetParam = `${suffix}/device/deviceInfor_updateSetParam`
		const deviceInfor_updateSetParamV2 = `${suffix}/device/deviceInfor_updateSetParamV2`
		const deviceInfor_batchUpdateSetParam = `${suffix}/device/deviceInfor_batchUpdateSetParam`
		const deviceInfor_curveData = `${suffix}/device/deviceInfor_curveData`
		const deviceInfor_updateBatch = `${suffix}/device/deviceInfor_updateBatch`
		const deviceInfor_updateBdzt = `${suffix}/device/deviceInfor_updateBdzt`
		const deviceInfor_updateBatchSetZt = `${suffix}/device/deviceInfor_updateBatchSetZt`
		const deviceInfor_batchHeart = `${suffix}/device/deviceInfor_batchHeart`
		const deviceInfor_updateRlcl = `${suffix}/device/deviceInfor_updateRlcl`
		const deviceInfor_updateRlclV2 = `${suffix}/device/deviceInfor_updateRlclV2`
		const deviceInfor_updateDw = `${suffix}/device/deviceInfor_updateDw`
		const deviceInfor_updateMathPutAndUse = `${suffix}/device/deviceInfor_updateMathPutAndUse`
		const deviceInfor_updateAllRlclV2 = `${suffix}/device/deviceInfor_updateAllRlclV2`
		const deviceInfor_updateSetQhParam = `${suffix}/device/deviceInfor_updateSetQhParam`

		//迁移IP
		const deviceIps_list = `${suffix}/device/deviceIps_list`
		const deviceIps_getDetail = `${suffix}/device/deviceIps_getDetail`
		const deviceIps_saveOrUpdate = `${suffix}/device/deviceIps_saveOrUpdate`
		const deviceIps_delete = `${suffix}/device/deviceIps_delete`
		const deviceIps_updateSh = `${suffix}/device/deviceIps_updateSh`
		const deviceIps_importExcel = `${suffix}/device/deviceIps_importExcel`
		const deviceIps_downImportModel = `${suffix}/device/deviceIps_downImportModel`
		const deviceIps_exportExcel = `${suffix}/device/deviceIps_exportExcel`

		//砂浆罐连接日志
		const deviceConLog_list = `${suffix}/device/deviceConLog_list`
		const deviceConLog_getDetail = `${suffix}/device/deviceConLog_getDetail`
		const deviceConLog_saveOrUpdate = `${suffix}/device/deviceConLog_saveOrUpdate`
		const deviceConLog_delete = `${suffix}/device/deviceConLog_delete`
		const deviceConLog_updateSh = `${suffix}/device/deviceConLog_updateSh`
		const deviceConLog_importExcel = `${suffix}/device/deviceConLog_importExcel`
		const deviceConLog_downImportModel = `${suffix}/device/deviceConLog_downImportModel`
		const deviceConLog_exportExcel = `${suffix}/device/deviceConLog_exportExcel`

		//操作记录
		const deviceOpLog_list = `${suffix}/device/deviceOpLog_list`
		const deviceOpLog_getDetail = `${suffix}/device/deviceOpLog_getDetail`
		const deviceOpLog_saveOrUpdate = `${suffix}/device/deviceOpLog_saveOrUpdate`
		const deviceOpLog_delete = `${suffix}/device/deviceOpLog_delete`
		const deviceOpLog_updateSh = `${suffix}/device/deviceOpLog_updateSh`
		const deviceOpLog_importExcel = `${suffix}/device/deviceOpLog_importExcel`
		const deviceOpLog_downImportModel = `${suffix}/device/deviceOpLog_downImportModel`
		const deviceOpLog_exportExcel = `${suffix}/device/deviceOpLog_exportExcel`
		const deviceOpLog_getIndexData = `${suffix}/device/deviceOpLog_getIndexData`


		


		//DeviceSimState
		const deviceSimState_list = `${suffix}/device/deviceSimState_list`
		const deviceSimState_getDetail = `${suffix}/device/deviceSimState_getDetail`
		const deviceSimState_saveOrUpdate = `${suffix}/device/deviceSimState_saveOrUpdate`
		const deviceSimState_delete = `${suffix}/device/deviceSimState_delete`
		const deviceSimState_updateSh = `${suffix}/device/deviceSimState_updateSh`
		const deviceSimState_importExcel = `${suffix}/device/deviceSimState_importExcel`
		const deviceSimState_downImportModel = `${suffix}/device/deviceSimState_downImportModel`
		const deviceSimState_exportExcel = `${suffix}/device/deviceSimState_exportExcel`
		const deviceSimState_getDetailForIccid = `${suffix}/device/deviceSimState_getDetailForIccid`
		const deviceSimState_reloadData = `${suffix}/device/deviceSimState_reloadData`

		//砂浆罐迁移记录
		const deviceTransfer_list = `${suffix}/device/deviceTransfer_list`
		const deviceTransfer_getDetail = `${suffix}/device/deviceTransfer_getDetail`
		const deviceTransfer_saveOrUpdate = `${suffix}/device/deviceTransfer_saveOrUpdate`
		const deviceTransfer_delete = `${suffix}/device/deviceTransfer_delete`
		const deviceTransfer_updateSh = `${suffix}/device/deviceTransfer_updateSh`
		const deviceTransfer_importExcel = `${suffix}/device/deviceTransfer_importExcel`
		const deviceTransfer_downImportModel = `${suffix}/device/deviceTransfer_downImportModel`
		const deviceTransfer_exportExcel = `${suffix}/device/deviceTransfer_exportExcel`

		//DeviceVariable
		const deviceVariable_list = `${suffix}/device/deviceVariable_list`
		const deviceVariable_getList = `${suffix}/device/deviceVariable_getList`
		const deviceVariable_getDetail = `${suffix}/device/deviceVariable_getDetail`
		const deviceVariable_saveOrUpdate = `${suffix}/device/deviceVariable_saveOrUpdate`
		const deviceVariable_delete = `${suffix}/device/deviceVariable_delete`
		const deviceVariable_listForDeviceId = `${suffix}/device/deviceVariable_listForDeviceId`
 
		//车货运记录
		const deviceCarRecord_list = `${suffix}/device/deviceCarRecord_list`
		const deviceCarRecord_getDetail = `${suffix}/device/deviceCarRecord_getDetail`
		const deviceCarRecord_saveOrUpdate = `${suffix}/device/deviceCarRecord_saveOrUpdate`
		const deviceCarRecord_delete = `${suffix}/device/deviceCarRecord_delete`
		const deviceCarRecord_updateSh = `${suffix}/device/deviceCarRecord_updateSh`
		const deviceCarRecord_importExcel = `${suffix}/device/deviceCarRecord_importExcel`
		const deviceCarRecord_downImportModel = `${suffix}/device/deviceCarRecord_downImportModel`
		const deviceCarRecord_exportExcel = `${suffix}/device/deviceCarRecord_exportExcel`


		//报警类型
		const deviceAlarmType_list = `${suffix}/device/deviceAlarmType_list`
		const deviceAlarmType_getDetail = `${suffix}/device/deviceAlarmType_getDetail`
		const deviceAlarmType_saveOrUpdate = `${suffix}/device/deviceAlarmType_saveOrUpdate`
		const deviceAlarmType_delete = `${suffix}/device/deviceAlarmType_delete`
		const deviceAlarmType_updateSh = `${suffix}/device/deviceAlarmType_updateSh`
		const deviceAlarmType_importExcel = `${suffix}/device/deviceAlarmType_importExcel`
		const deviceAlarmType_downImportModel = `${suffix}/device/deviceAlarmType_downImportModel`
		const deviceAlarmType_exportExcel = `${suffix}/device/deviceAlarmType_exportExcel`

		//报警记录
		const deviceAlarm_list = `${suffix}/device/deviceAlarm_list`
		const deviceAlarm_getDetail = `${suffix}/device/deviceAlarm_getDetail`
		const deviceAlarm_updateCz = `${suffix}/device/deviceAlarm_updateCz`
		const deviceAlarm_delete = `${suffix}/device/deviceAlarm_delete`
		const deviceAlarm_updateSh = `${suffix}/device/deviceAlarm_updateSh`
		const deviceAlarm_importExcel = `${suffix}/device/deviceAlarm_importExcel`
		const deviceAlarm_downImportModel = `${suffix}/device/deviceAlarm_downImportModel`
		const deviceAlarm_exportExcel = `${suffix}/device/deviceAlarm_exportExcel`

		//Product
		const product_list = `${suffix}/device/product_list`
		const product_listCom = `${suffix}/device/product_listCom`
		const product_listAll = `${suffix}/device/product_listAll`
		const product_getDetail = `${suffix}/device/product_getDetail`
		const product_saveOrUpdate = `${suffix}/device/product_saveOrUpdate`
		const product_delete = `${suffix}/device/product_delete`
		const product_updateParamsCont = `${suffix}/device/product_updateParamsCont`

	

		//企业用户
		const companyUser_list = `${suffix}/company/companyUser_list`
		const companyUser_getDetail = `${suffix}/company/companyUser_getDetail`
		const companyUser_saveOrUpdate = `${suffix}/company/companyUser_saveOrUpdate`
		const companyUser_delete = `${suffix}/company/companyUser_delete`
		const companyUser_updateSh = `${suffix}/company/companyUser_updateSh`
		const companyUser_importExcel = `${suffix}/company/companyUser_importExcel`
		const companyUser_downImportModel = `${suffix}/company/companyUser_downImportModel`
		const companyUser_exportExcel = `${suffix}/company/companyUser_exportExcel`
		const companyUser_updateSetPd = `${suffix}/company/companyUser_updateSetPd`
		const companyUser_updateDefaultProduct = `${suffix}/company/companyUser_updateDefaultProduct`

		const company_getTreeNode = `${suffix}/company/company_getTreeNode`

	


		//实时库配置
		const realConfig_list = `${suffix}/device/realConfig_list`
		const realConfig_getDetail = `${suffix}/device/realConfig_getDetail`
		const realConfig_saveOrUpdate = `${suffix}/device/realConfig_saveOrUpdate`
		const realConfig_delete = `${suffix}/device/realConfig_delete`
		const realConfig_updateSh = `${suffix}/device/realConfig_updateSh`
		const realConfig_importExcel = `${suffix}/device/realConfig_importExcel`
		const realConfig_downImportModel = `${suffix}/device/realConfig_downImportModel`
		const realConfig_exportExcel = `${suffix}/device/realConfig_exportExcel`

		//统计分析
		const tjfxOnlineState_list = `${suffix}/tjfx/tjfxOnlineState_list`
		const tjfxOnlineState_getCurveData = `${suffix}/tjfx/tjfxOnlineState_getCurveData`
		const tjfx_getDeviceFl = `${suffix}/tjfx/tjfx_getDeviceFl`
		const tjfx_export = `${suffix}/tjfx/tjfx_export`

		const sysDictItem_list = `${suffix}/sys/sysDictItem_list`
		const sysDictItem_getDetail = `${suffix}/sys/sysDictItem_getDetail`
		const sysDictItem_saveOrUpdate = `${suffix}/sys/sysDictItem_saveOrUpdate`
		const sysDictItem_delete = `${suffix}/sys/sysDictItem_delete`

		const tjfx_getSjgMapData = `${suffix}/tjfx/tjfx_getSjgMapData`
		const tjfx_getSjgMapStat = `${suffix}/tjfx/tjfx_getSjgMapStat`
		const devicePutLog_getRlbbData = `${suffix}/device/devicePutLog_getRlbbData`
		const devicePutLog_getYlbbData = `${suffix}/device/devicePutLog_getYlbbData`


		const analysisRules_list = `${suffix}/device/analysisRules_list`
		const analysisRules_getDetail = `${suffix}/device/analysisRules_getDetail`
		const analysisRules_saveOrUpdate = `${suffix}/device/analysisRules_saveOrUpdate`
		const analysisRules_delete = `${suffix}/device/analysisRules_delete`
		const analysisRules_updateSh = `${suffix}/device/analysisRules_updateSh`
		const analysisRules_updateBatch = `${suffix}/device/analysisRules_updateBatch`
		const analysisRules_importExcel = `${suffix}/device/analysisRules_importExcel`
		const analysisRules_downImportModel = `${suffix}/device/analysisRules_downImportModel`
		const analysisRules_exportExcel = `${suffix}/device/analysisRules_exportExcel`
		const analysisRules_getWebConfig = `${suffix}/device/analysisRules_getWebConfig`

		//分组
		const analysisGroup_list = `${suffix}/device/analysisGroup_list`
		const analysisGroup_saveOrUpdate = `${suffix}/device/analysisGroup_saveOrUpdate`
		const analysisGroup_delete = `${suffix}/device/analysisGroup_delete`
		const analysisGroup_listCom = `${suffix}/device/analysisGroup_listCom`
		//解析参数

		//预警配置
		const deviceAlarmConfig_list = `${suffix}/device/deviceAlarmConfig_list`
		const deviceAlarmConfig_listForDeviceId = `${suffix}/device/deviceAlarmConfig_listForDeviceId`
		const deviceAlarmConfig_getDetail = `${suffix}/device/deviceAlarmConfig_getDetail`
		const deviceAlarmConfig_saveOrUpdate = `${suffix}/device/deviceAlarmConfig_saveOrUpdate`
		const deviceAlarmConfig_delete = `${suffix}/device/deviceAlarmConfig_delete`

		const deviceAlarmConfigItem_saveMore = `${suffix}/device/deviceAlarmConfigItem_saveMore`
		const deviceAlarmConfigItem_list = `${suffix}/device/deviceAlarmConfigItem_list`
		const deviceAlarmConfigItem_getDetail = `${suffix}/device/deviceAlarmConfigItem_getDetail`
		const deviceAlarmConfigItem_saveOrUpdate = `${suffix}/device/deviceAlarmConfigItem_saveOrUpdate`
		const deviceAlarmConfigItem_delete = `${suffix}/device/deviceAlarmConfigItem_delete`

		//预警配置类型
		const deviceAlarmConfigType_list = `${suffix}/device/deviceAlarmConfigType_list`
		const deviceAlarmConfigType_getDetail = `${suffix}/device/deviceAlarmConfigType_getDetail`
		const deviceAlarmConfigType_saveOrUpdate = `${suffix}/device/deviceAlarmConfigType_saveOrUpdate`
		const deviceAlarmConfigType_delete = `${suffix}/device/deviceAlarmConfigType_delete`
		const deviceAlarmConfigType_listCom = `${suffix}/device/deviceAlarmConfigType_listCom`

		//轮播主题
		const carousel_list = `${suffix}/carousel/carousel_list`
		const carousel_listItem = `${suffix}/carousel/carousel_listItem`
		const carousel_getDetail = `${suffix}/carousel/carousel_getDetail`
		const carousel_saveOrUpdate = `${suffix}/carousel/carousel_saveOrUpdate`
		const carousel_delete = `${suffix}/carousel/carousel_delete`

		//轮播图图片
		const carouselItem_list = `${suffix}/carousel/carouselItem_list`
		const carouselItem_getDetail = `${suffix}/carousel/carouselItem_getDetail`
		const carouselItem_saveOrUpdate = `${suffix}/carousel/carouselItem_saveOrUpdate`
		const carouselItem_delete = `${suffix}/carousel/carouselItem_delete`

		//解析参数
		const analysisParamName_list = `${suffix}/device/analysisParamName_list`
		const analysisParamName_getDetail = `${suffix}/device/analysisParamName_getDetail`
		const analysisParamName_saveOrUpdate = `${suffix}/device/analysisParamName_saveOrUpdate`
		const analysisParamName_delete = `${suffix}/device/analysisParamName_delete`
		//解析参数名称获取
		const analysisParamName_listParam = `${suffix}/device/analysisParamName_listParam`
		const analysisParamName_updateSync = `${suffix}/device/analysisParamName_updateSync`
		const analysisParamName_updateBath = `${suffix}/device/analysisParamName_updateBath`

		//ParamBtn
		const paramBtn_list = `${suffix}/device/paramBtn_list`
		const paramBtn_getDetail = `${suffix}/device/paramBtn_getDetail`
		const paramBtn_saveOrUpdate = `${suffix}/device/paramBtn_saveOrUpdate`
		const paramBtn_delete = `${suffix}/device/paramBtn_delete`

		//ParamBtnItem
		const paramBtnItem_list = `${suffix}/device/paramBtnItem_list`
		const paramBtnItem_getDetail = `${suffix}/device/paramBtnItem_getDetail`
		const paramBtnItem_saveOrUpdate = `${suffix}/device/paramBtnItem_saveOrUpdate`
		const paramBtnItem_delete = `${suffix}/device/paramBtnItem_delete`
		const paramBtnItem_updateBath = `${suffix}/device/paramBtnItem_updateBath`

		//CompanyData
		const companyData_list = `${suffix}/company/companyData_list`
		const companyData_getDetail = `${suffix}/company/companyData_getDetail`
		const companyData_saveOrUpdate = `${suffix}/company/companyData_saveOrUpdate`
		const companyData_delete = `${suffix}/company/companyData_delete`
	 	const companyData_updateData = `${suffix}/company/companyData_updateData`

		//认证
		const oauthClientDetails_list = `${suffix}/sys/oauthClientDetails_list`
		const oauthClientDetails_getDetail = `${suffix}/sys/oauthClientDetails_getDetail`
		const oauthClientDetails_saveOrUpdate = `${suffix}/sys/oauthClientDetails_saveOrUpdate`
		const oauthClientDetails_delete = `${suffix}/sys/oauthClientDetails_delete`
		const oauthClientDetails_updateSh = `${suffix}/sys/oauthClientDetails_updateSh`

		//称重历史记录
		const deviceWeightLog_list = `${suffix}/device/deviceWeightLog_list`
		const deviceWeightLog_listXmc = `${suffix}/device/deviceWeightLog_listXmc`
		const deviceWeightLog_getDetail = `${suffix}/device/deviceWeightLog_getDetail`
		const deviceWeightLog_getXmcCurveData = `${suffix}/device/deviceWeightLog_getXmcCurveData`
		const deviceWeightLog_saveOrUpdate = `${suffix}/device/deviceWeightLog_saveOrUpdate`
		const deviceWeightLog_delete = `${suffix}/device/deviceWeightLog_delete`
		const deviceWeightLog_updateSh = `${suffix}/device/deviceWeightLog_updateSh`
		const deviceWeightLog_importExcel = `${suffix}/device/deviceWeightLog_importExcel`
		const deviceWeightLog_downImportModel = `${suffix}/device/deviceWeightLog_downImportModel`
		const deviceWeightLog_exportExcel = `${suffix}/device/deviceWeightLog_exportExcel`


		//设备主子关联关系
		const deviceSubRelation_list = `${suffix}/device/deviceSubRelation_list`
		const deviceSubRelation_getDetail = `${suffix}/device/deviceSubRelation_getDetail`
		const deviceSubRelation_saveOrUpdate = `${suffix}/device/deviceSubRelation_saveOrUpdate`
		const deviceSubRelation_delete = `${suffix}/device/deviceSubRelation_delete`
		const deviceSubRelation_getList = `${suffix}/device/deviceSubRelation_getList`


 		const helpFlag_getDetail = `${suffix}/sys/helpFlag_getDetail`


		return{
			login,
			getRealData,
			getRealDataForChart,
			getRealDataForChartNm,
			index_statData,
			index_statData2,
			commonLog_list,
			updateFileUrlOne,
			sysLog_list,
			sysLog_getDetail,
			sysRole_list,
			sysRole_save,
			sysRole_update,
			sysRole_listCom,
			sysRole_getCompanyRoleList,
			sysRole_delete,
			sysRole_getDetail,
			sysDept_list,
			sysDept_save,
			sysDept_update,
			sysDept_delete,
			sysDept_getDetail,
			sysDept_listCom,
			sysUser_list,
			sysUser_getSessionUser,
			sysUser_save,
			sysUser_delete,
			sysUser_getDetail,
			sysUser_updatePassword,
			sysUser_updateParams,
			sysPower_saveUserRoles,
			sysPower_listUserModule,
			sysUser_getUserRolesTree,
			cache_clear,
			getmessage,
			sysPower_getTopMenu,
			menuByUser,
			sysdept_listWeb,
			sysPower_getRoleModulesTree,
			sysPower_saveRoleModules,
			appFeedback_list,
			appFeedback_indexData,
			appFeedback_getDetail,
			appFeedback_save,
			appFeedback_delete,
			appFeedback_updateCl,
			task_list,
			task_getDetail,
			task_delete,
			task_updateSetRead,
			task_getNoDeal,
			company_list,
			company_getDetail,
			company_saveOrUpdate,
			company_delete,
			company_updateSh,
			company_importExcel,
			company_downImportModel,
			company_exportExcel,
			company_listCom,
			company_updateAllNums,
			company_updateForCompanyUser,
			company_updateParams,
			company_migration,
			company_getTreeNodeV2,
			company_getInfor,
			company_getDetailByUser,
			deviceVersion_list,
			deviceVersion_getDetail,
			deviceVersion_saveOrUpdate,
			deviceVersion_delete,
			deviceVersion_exportExcel,
			deviceVersionLog_list,
			deviceVersionLog_exportExcel,
			deviceVersion_listForDeviceId,
			deviceAfterSalesApply_list,
			deviceAfterSalesApply_getDetail,
			deviceAfterSalesApply_saveOrUpdate,
			deviceAfterSalesApply_delete,
			deviceAfterSalesApply_updateSh,
			deviceAfterSalesApply_importExcel,
			deviceAfterSalesApply_downImportModel,
			deviceAfterSalesApply_exportExcel,
			deviceAfterSalesRecord_updateDeal,
			deviceAfterSalesApply_listNoDealData,
			deviceInforState_list,
			deviceInforState_getDetail,
			deviceInforState_saveOrUpdate,
			deviceInforState_delete,
			deviceInforState_updateSh,
			deviceInforState_importExcel,
			deviceInforState_downImportModel,
			deviceInforState_exportExcel,
			deviceInfor_list,
			deviceInfor_getDetail,
			deviceInfor_getAllDetail,
			deviceInfor_getUseAndPutLog,
			deviceInfor_getUseAndPutChart,
			deviceInfor_saveOrUpdate,
			deviceInfor_saveMore,
			deviceInfor_delete,
			deviceInfor_getSum,
			deviceInfor_saveMigrate,
			deviceInfor_importExcel,
			deviceInfor_importExcelAli,
			deviceInfor_downImportModel,
			deviceInfor_downImportModelAli,
			deviceInfor_exportExcel,
			deviceInfor_curveData,
			deviceInfor_updateRlcl,
			deviceInfor_updateRlclV2,
			deviceInfor_updateDw,
			deviceInfor_updateMathPutAndUse,
			deviceInfor_updateAllRlclV2,
			deviceConLog_list,
			deviceConLog_getDetail,
			deviceConLog_saveOrUpdate,
			deviceConLog_delete,
			deviceConLog_updateSh,
			deviceConLog_importExcel,
			deviceConLog_downImportModel,
			deviceConLog_exportExcel,
			deviceOpLog_list,
			deviceOpLog_getDetail,
			deviceOpLog_saveOrUpdate,
			deviceOpLog_delete,
			deviceOpLog_updateSh,
			deviceOpLog_importExcel,
			deviceOpLog_downImportModel,
			deviceOpLog_exportExcel,
			deviceOpLog_getIndexData,
			deviceSimState_list,
			deviceSimState_getDetail,
			deviceSimState_saveOrUpdate,
			deviceSimState_delete,
			deviceSimState_updateSh,
			deviceSimState_importExcel,
			deviceSimState_downImportModel,
			deviceSimState_exportExcel,
			deviceSimState_getDetailForIccid,
			deviceSimState_reloadData,
			deviceTransfer_list,
			deviceTransfer_getDetail,
			deviceTransfer_saveOrUpdate,
			deviceTransfer_delete,
			deviceTransfer_updateSh,
			deviceTransfer_importExcel,
			deviceTransfer_downImportModel,
			deviceTransfer_exportExcel,
			deviceVariable_list,
			deviceVariable_getList,
			deviceVariable_getDetail,
			deviceVariable_saveOrUpdate,
			deviceVariable_delete,
			deviceVariable_listForDeviceId,
			product_list,
			product_listCom,
			product_listAll,
			product_getDetail,
			product_saveOrUpdate,
			product_delete,
			product_updateParamsCont,
			deviceAlarm_list,
			deviceAlarm_getDetail,
			deviceAlarm_updateCz,
			deviceAlarm_delete,
			deviceAlarm_updateSh,
			deviceAlarm_importExcel,
			deviceAlarm_downImportModel,
			deviceAlarm_exportExcel,
			deviceAlarmType_list,
			deviceAlarmType_getDetail,
			deviceAlarmType_saveOrUpdate,
			deviceAlarmType_delete,
			deviceAlarmType_updateSh,
			deviceAlarmType_importExcel,
			deviceAlarmType_downImportModel,
			deviceAlarmType_exportExcel,
			deviceCarRecord_list,
			deviceCarRecord_getDetail,
			deviceCarRecord_saveOrUpdate,
			deviceCarRecord_delete,
			deviceCarRecord_updateSh,
			deviceCarRecord_importExcel,
			deviceCarRecord_downImportModel,
			deviceCarRecord_exportExcel,
			deviceIps_list,
			deviceIps_getDetail,
			deviceIps_saveOrUpdate,
			deviceIps_delete,
			deviceIps_updateSh,
			deviceIps_importExcel,
			deviceIps_downImportModel,
			deviceIps_exportExcel,
			companyUser_list,
			companyUser_getDetail,
			companyUser_saveOrUpdate,
			companyUser_updateSetPd,
			companyUser_updateDefaultProduct,
			companyUser_delete,
			companyUser_updateSh,
			companyUser_importExcel,
			companyUser_downImportModel,
			companyUser_exportExcel,
			company_getTreeNode,
			deviceInfor_getAuto,
			deviceInfor_updateSetParam,
			deviceInfor_updateSetParamV2,
			deviceInfor_batchUpdateSetParam,
			deviceInfor_updateSetZt,
			deviceInfor_updateSetZtV2,
			deviceInfor_updateBatch,
			deviceInfor_updateBdzt,
			deviceInfor_updateBatchSetZt,
			deviceInfor_batchHeart,
			realConfig_list,
			realConfig_getDetail,
			realConfig_saveOrUpdate,
			realConfig_delete,
			realConfig_updateSh,
			realConfig_importExcel,
			realConfig_downImportModel,
			realConfig_exportExcel,
			sysDict_saveOrUpdateItem,
			sysDict_listItemByCode,
			sysDict_deleteItem,
			sysDict_listItem,
			sysDict_listItemByDictId,
			sysDict_listComByDictId,
			tjfxOnlineState_list,
			tjfxOnlineState_getCurveData,
			tjfx_getDeviceFl,
			tjfx_export,
			sysDict_listItemByDesc,
			sysDict_listItemByDictIdAndDesc,
			sysDict_getForCode,
			sysDict_list,
			sysDict_getDetail,
			sysDictItem_list,
			sysDictItem_getDetail,
			sysDictItem_saveOrUpdate,
			sysDictItem_delete,
			tjfx_getSjgMapData,
			tjfx_getSjgMapStat,
			devicePutLog_getRlbbData,
			devicePutLog_getYlbbData,
			analysisRules_list,
			analysisRules_getDetail,
			analysisRules_saveOrUpdate,
			analysisRules_delete,
			analysisRules_updateSh,
			analysisRules_updateBatch,
			analysisRules_importExcel,
			analysisRules_downImportModel,
			analysisRules_exportExcel,
			analysisRules_getWebConfig,
			analysisGroup_list,
			analysisGroup_saveOrUpdate,
			analysisGroup_delete,
			analysisGroup_listCom,
			deviceAlarmConfig_list,
			deviceAlarmConfig_listForDeviceId,
			deviceAlarmConfig_getDetail,
			deviceAlarmConfig_saveOrUpdate,
			deviceAlarmConfig_delete,
			deviceAlarmConfigItem_saveMore,
			deviceAlarmConfigItem_list,
			deviceAlarmConfigItem_getDetail,
			deviceAlarmConfigItem_saveOrUpdate,
			deviceAlarmConfigItem_delete,
			deviceAlarmConfigType_list,
			deviceAlarmConfigType_getDetail,
			deviceAlarmConfigType_saveOrUpdate,
			deviceAlarmConfigType_delete,
			deviceAlarmConfigType_listCom,
			carouselItem_list,
			carouselItem_getDetail,
			carouselItem_saveOrUpdate,
			carouselItem_delete,
			carousel_list,
			carousel_listItem,
			carousel_getDetail,
			carousel_saveOrUpdate,
			carousel_delete,
			analysisParamName_list,
			analysisParamName_getDetail,
			analysisParamName_saveOrUpdate,
			analysisParamName_delete,
			analysisParamName_listParam,
			analysisParamName_updateSync,
			analysisParamName_updateBath,

			paramBtn_list,
			paramBtn_getDetail,
			paramBtn_saveOrUpdate,
			paramBtn_delete,
			paramBtnItem_list,
			paramBtnItem_getDetail,
			paramBtnItem_saveOrUpdate,
			paramBtnItem_delete,
			paramBtnItem_updateBath,

			companyData_list,
			companyData_getDetail,
			companyData_saveOrUpdate,
			companyData_delete,
			companyData_updateData,

			oauthClientDetails_list,
			oauthClientDetails_getDetail,
			oauthClientDetails_saveOrUpdate,
			oauthClientDetails_delete,
			oauthClientDetails_updateSh,

			deviceSubRelation_list,
			deviceSubRelation_getDetail,
			deviceSubRelation_saveOrUpdate,
			deviceSubRelation_delete,
			deviceSubRelation_getList,

			deviceWeightLog_list,
			deviceWeightLog_listXmc,
			deviceWeightLog_getDetail,
			deviceWeightLog_getXmcCurveData,
			deviceWeightLog_saveOrUpdate,
			deviceWeightLog_delete,
			deviceWeightLog_updateSh,
			deviceWeightLog_importExcel,
			deviceWeightLog_downImportModel,
			deviceWeightLog_exportExcel,

			helpFlag_getDetail,
			deviceInfor_updateSetQhParam,

		}
	}
}

export default urls
